'use client';

import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { useGuest } from '@/app/hooks/useGuest';
import { GuestModeDescription } from '~/components/commons/GuestModeAccess/GuestModeDescription';
import { RequestStatus, useRequestState } from '~/hooks/request/useRequestState';
import { Loader } from '../Loader';

export const AuthInfo = ({ guestAllowed }: { guestAllowed?: boolean }) => {
  const t = useTranslations();
  const { id } = useParams<{ id: string }>();

  const { redirectToLogin } = useAuthenticatedContext();
  const { startRequest, handleSuccess, status } = useRequestState();

  const { isFetching, init } = useGuest(!guestAllowed, +id);

  const handleGuestAccess = async () => {
    startRequest();
    await init();

    handleSuccess();
  };

  return (
    <Loader loading={status !== RequestStatus.IDLE} size="large">
      <section data-testid="auth-info" className="auth-info">
        <div className="auth-info__wrapper">
          <header className="auth-info__header vp-title-l">
            {t('GUEST_MODAL.TITLE')}
          </header>
          <div className="auth-info__body vp-body-m">
            <GuestModeDescription />
          </div>
          <footer className="auth-info__footer">
            {guestAllowed && (
              <VpButton
                data-testid="guest-mode-access-action"
                data-cy="guest-mode-access-action"
                disabled={isFetching}
                variant="secondary"
                onClick={() => handleGuestAccess()}
              >
                {t('GUEST_MODAL.GUEST_MODE_CTA_LABEL')}
              </VpButton>
            )}
            <VpButton
              disabled={isFetching}
              onClick={async () => await redirectToLogin()}
            >
              {t('GLOBAL.LOGIN')}
            </VpButton>
          </footer>
        </div>
      </section>
    </Loader>
  );
};
